export default __webpack_public_path__ + "static/media/logo_header.2f9a8fc8.svg";